import {
  GraphQlClient,
  Lodash,
  Auth,
} from '@intelipost-js/secure-providers';

import { ScToast } from '@intelipost-js/secure-components';


export default {
  getQuotingReturns({ commit }, params) {
    const paramsCustom = {
      ...params,
      production: Auth.getUser().is_production,
    };
    commit('toggleLoading', true);
    return GraphQlClient.query(`
      query($production: Boolean!) {
        quotingReturnApi(production: $production) {
          id
          production
          limit
          duplicates
          config_list {
            id
            client_id
            mode_type
            status
            name
            priority
            created
            modified
            quote_option_type
            delivery_method {
              id
              type
              type_id
            }
            condition {
              param
              value
            }
            custom_condition_parameters {
              param_type
              value
            }
            actions {
              label
              action_condition {
                param
                value
              }
            }
            quote_option_type_id
            order
            condition_as_string
            rule_type
          }
          return_mode_type
          quote_option_type
          sort_type_id
          sort_type
          sort_mode
          type_id
        }
      }`, paramsCustom)
      .then(({ data = {} }) => {
        const { quotingReturnApi = {} } = data || {};
        commit('toggleLoading', false);
        commit('setQuotingReturns', quotingReturnApi);
        return Promise.resolve(data);
      }).catch((err) => {
        commit('toggleLoading', false);
        return Promise.reject(err);
      });
  },

  updateQuotingReturnsAll({ commit }, params) {
    commit('toggleLoading', true);
    return GraphQlClient.mutation(
      `mutation(
        $id: Int
        $limit: Int
        $duplicates: Boolean
        $config_list: [ConfigItemInput]
        $return_mode_type: String
        $quote_option_type: String
        $sort_type_id: Int
        $sort_type: String
        $sort_mode: String
        $type_id: Int
        $production: Boolean!
      ) {
        updateQuotingApiReturn (
          id: $id
          limit: $limit
          duplicates: $duplicates
          config_list: $config_list
          return_mode_type: $return_mode_type
          quote_option_type: $quote_option_type
          sort_type_id: $sort_type_id
          sort_type: $sort_type
          sort_mode: $sort_mode
          type_id: $type_id
          production: $production
        ) {
          id
          limit
          duplicates
          config_list {
            id
          }
          return_mode_type
          quote_option_type
          sort_type
          sort_type_id
          sort_mode
          type_id
        }
      }`, params)
    .then(({ data = {} }) => {
      commit('toggleLoading', false);
      const { updateQuotingApiReturn = {} } = data || {};
      commit('setQuotingReturns', updateQuotingApiReturn);
      ScToast.success('Resultados foram gravados com sucesso');
      return Promise.resolve(data);
    }).catch((err) => {
      commit('toggleLoading', false);
      return Promise.reject(err);
    });
  },

  updateQuotingReturnsFilters({ commit, dispatch }, params) {
    const {
      quotingReturns = {},
      configList = [],
      typeId = 0,
      returnModeType = '',
      production,
    } = params;

    const fmtConfigList = configList.map(configItem => Lodash.omit(configItem, ['rule_type']));

    const param = Object.assign(
      quotingReturns,
      {
        config_list: fmtConfigList,
        limit: configList.length,
        type_id: typeId,
        return_mode_type: returnModeType,
        production,
      },
    );

    commit('toggleLoading', true);
    return GraphQlClient.mutation(`
      mutation(
        $id: Int
        $limit: Int
        $duplicates: Boolean
        $config_list: [ConfigItemInput]
        $return_mode_type: String
        $quote_option_type: String
        $sort_type_id: Int
        $sort_type: String
        $sort_mode: String
        $type_id: Int
      ) {
        updateQuotingApiReturnFilters (
          id: $id
          limit: $limit
          duplicates: $duplicates
          config_list: $config_list
          return_mode_type: $return_mode_type
          quote_option_type: $quote_option_type
          sort_type_id: $sort_type_id
          sort_type: $sort_type
          sort_mode: $sort_mode
          type_id: $type_id
        ) {
          id
          limit
          duplicates
          config_list {
            status
            name
            priority
            delivery_method {
              type_id
            }
            quote_option_type_id
            order
          }
          return_mode_type
          quote_option_type
          sort_type
          sort_type_id
          sort_mode
          type_id
        }
      }`, param)
    .then(({ data = {} }) => {
      dispatch('getQuotingReturns', params);
      commit('toggleLoading', false);
      ScToast.success('Resultados foram gravados com sucesso');
      return Promise.resolve(data);
    }).catch((err) => {
      commit('toggleLoading', false);
      return Promise.reject(err);
    });
  },

  updateQuotingReturnsFixed({ commit, dispatch }, params) {
    const {
      quotingReturns = {},
      configList = [],
      typeId = 0,
      returnModeType = '',
      production,
    } = params;

    const fmtConfigList = configList.map(configItem => Lodash.omit(configItem, ['rule_type']));

    const param = Object.assign(
      quotingReturns,
      {
        config_list: fmtConfigList,
        limit: configList.length,
        type_id: typeId,
        return_mode_type: returnModeType,
        production,
      },
    );

    commit('toggleLoading', true);
    return GraphQlClient.mutation(`
      mutation(
        $id: Int
        $limit: Int
        $duplicates: Boolean
        $config_list: [ConfigItemInput]
        $return_mode_type: String
        $quote_option_type: String
        $sort_type_id: Int
        $sort_type: String
        $sort_mode: String
        $type_id: Int
      ) {
        updateQuotingApiReturnFixed (
          id: $id
          limit: $limit
          duplicates: $duplicates
          config_list: $config_list
          return_mode_type: $return_mode_type
          quote_option_type: $quote_option_type
          sort_type_id: $sort_type_id
          sort_type: $sort_type
          sort_mode: $sort_mode
          type_id: $type_id
        ) {
          id
          limit
          duplicates
          config_list {
            status
            name
            priority
            delivery_method {
              id
            }
            order
          }
          return_mode_type
          quote_option_type
          sort_type
          sort_type_id
          sort_mode
          type_id
        }
      }`, param)
    .then(({ data = {} }) => {
      dispatch('getQuotingReturns', params);
      commit('toggleLoading', false);
      ScToast.success('Resultados foram gravados com sucesso');
      return Promise.resolve(data);
    }).catch((err) => {
      commit('toggleLoading', false);
      return Promise.reject(err);
    });
  },

  updateQuotingReturnsMixed({ commit, dispatch }, params) {
    const {
      quotingReturns = {},
      configList = [],
      typeId = 0,
      returnModeType = '',
      production,
    } = params;
    const param = Object.assign(
      quotingReturns,
      {
        config_list: configList,
        limit: configList.length,
        type_id: typeId,
        return_mode_type: returnModeType,
        production,
      },
    );
    commit('toggleLoading', true);
    return GraphQlClient.mutation(`
      mutation(
        $id: Int
        $limit: Int
        $duplicates: Boolean
        $config_list: [ConfigItemInput]
        $return_mode_type: String
        $quote_option_type: String
        $sort_type_id: Int
        $sort_type: String
        $sort_mode: String
        $type_id: Int
      ) {
        updateQuotingApiReturnMixed (
          id: $id
          limit: $limit
          duplicates: $duplicates
          config_list: $config_list
          return_mode_type: $return_mode_type
          quote_option_type: $quote_option_type
          sort_type_id: $sort_type_id
          sort_type: $sort_type
          sort_mode: $sort_mode
          type_id: $type_id
        ) {
          id
          limit
          duplicates
          config_list {
            status
            name
            priority
            delivery_method {
              id
              type_id
            }
            quote_option_type_id
            order
            rule_type
          }
          return_mode_type
          quote_option_type
          sort_type
          sort_type_id
          sort_mode
          type_id
        }
      }`, param)
    .then(({ data = {} }) => {
      dispatch('getQuotingReturns', params);
      commit('toggleLoading', false);
      ScToast.success('Resultados foram gravados com sucesso');
      return Promise.resolve(data);
    }).catch((err) => {
      commit('toggleLoading', false);
      return Promise.reject(err);
    });
  },

  updateQuotingReturnsDetails({ commit, dispatch }, params) {
    const {
      quotingReturns = {},
      configList = [],
      typeId = 0,
      returnModeType = '',
      production,
    } = params;

    const fmtConfigList = configList.map(configItem => Lodash.omit(configItem, ['rule_type', 'default_new_action']));

    const param = Object.assign(
      quotingReturns,
      {
        config_list: fmtConfigList,
        limit: configList.length,
        type_id: typeId,
        return_mode_type: returnModeType,
        production,
      },
    );

    commit('toggleLoading', true);
    return GraphQlClient.mutation(`
      mutation(
        $id: Int
        $limit: Int
        $duplicates: Boolean
        $config_list: [ConfigItemInput]
        $return_mode_type: String
        $quote_option_type: String
        $sort_type_id: Int
        $sort_type: String
        $sort_mode: String
        $type_id: Int
      ) {
        updateQuotingApiReturnDetail (
          id: $id
          limit: $limit
          duplicates: $duplicates
          config_list: $config_list
          return_mode_type: $return_mode_type
          quote_option_type: $quote_option_type
          sort_type_id: $sort_type_id
          sort_type: $sort_type
          sort_mode: $sort_mode
          type_id: $type_id
        ) {
          id
          limit
          duplicates
          config_list {
            id
            client_id
            status
            name
            priority
            created
            modified
            mode_type
            quote_option_type
            delivery_method {
              id
              type
              type_id
            }
            condition {
              param
              value
            }
            actions {
              label
              action_condition {
                param
                value
              }
            }
            quote_option_type_id
            order
            condition_as_string
            rule_type
          }
          return_mode_type
          quote_option_type
          sort_type
          sort_type_id
          sort_mode
          type_id
        }
      }`, param)
    .then(({ data = {} }) => {
      dispatch('getQuotingReturns', params);
      commit('toggleLoading', false);
      ScToast.success('Resultados foram gravados com sucesso');
      return Promise.resolve(data);
    }).catch((err) => {
      commit('toggleLoading', false);
      return Promise.reject(err);
    });
  },

  updateQuotingReturnsCustomCondition({ commit, dispatch }, params) {
    const {
      quotingReturns = {},
      configList = [],
      typeId = 0,
      returnModeType = '',
      production,
    } = params;

    const fmtConfigList = configList.map((configItem) => {
      const ommited = Lodash.omit(configItem, ['rule_type', 'default_new_custom_condition_parameter', 'actions']);
      return {
        ...ommited,
        delivery_method_type: configItem.condition.value !== 'DM' ? configItem.condition.param : null,
        delivery_method: configItem.condition.value !== 'DM' ? null : {
          id: configItem.condition.param,
          type: null,
          type_id: null,
        },
      };
    });

    const param = Object.assign(
      quotingReturns,
      {
        config_list: fmtConfigList,
        limit: configList.length,
        type_id: typeId,
        return_mode_type: returnModeType,
        production,
      },
    );

    commit('toggleLoading', true);
    return GraphQlClient.mutation(`
      mutation(
        $id: Int
        $limit: Int
        $duplicates: Boolean
        $config_list: [ConfigItemCustomConditionInput]
        $return_mode_type: String
        $quote_option_type: String
        $sort_type_id: Int
        $sort_type: String
        $sort_mode: String
        $type_id: Int
      ) {
        updateQuotingApiReturnCustomCondition (
          id: $id
          limit: $limit
          duplicates: $duplicates
          config_list: $config_list
          return_mode_type: $return_mode_type
          quote_option_type: $quote_option_type
          sort_type_id: $sort_type_id
          sort_type: $sort_type
          sort_mode: $sort_mode
          type_id: $type_id
        ) {
          id
          limit
          duplicates
          config_list {
            id
            client_id
            status
            name
            priority
            created
            modified
            mode_type
            quote_option_type
            delivery_method {
              id
              type
              type_id
            }
            delivery_method_type
            condition {
              value
            }
            custom_condition_parameters {
              param_type
              value
            }
            quote_option_type_id
            order
            condition_as_string
            rule_type
          }
          return_mode_type
          quote_option_type
          sort_type
          sort_type_id
          sort_mode
          type_id
        }
      }`, param)
    .then(({ data = {} }) => {
      dispatch('getQuotingReturns', params);
      commit('toggleLoading', false);
      ScToast.success('Resultados foram gravados com sucesso');
      return Promise.resolve(data);
    }).catch((err) => {
      commit('toggleLoading', false);
      return Promise.reject(err);
    });
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-quote/features/quoting-return/store/actions.js